// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Git = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Git = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  var Git = _exports.Git = function Git(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.5 6.75C8.74264 6.75 9.75 5.74264 9.75 4.5C9.75 3.25736 8.74264 2.25 7.5 2.25C6.25736 2.25 5.25 3.25736 5.25 4.5C5.25 5.74264 6.25736 6.75 7.5 6.75Z",
      stroke: "#212B36",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.5 21.75C8.74264 21.75 9.75 20.7426 9.75 19.5C9.75 18.2574 8.74264 17.25 7.5 17.25C6.25736 17.25 5.25 18.2574 5.25 19.5C5.25 20.7426 6.25736 21.75 7.5 21.75Z",
      stroke: "#212B36",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.5 17.25V6.75",
      stroke: "#212B36",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.5 9.75C17.7426 9.75 18.75 8.74264 18.75 7.5C18.75 6.25736 17.7426 5.25 16.5 5.25C15.2574 5.25 14.25 6.25736 14.25 7.5C14.25 8.74264 15.2574 9.75 16.5 9.75Z",
      stroke: "#212B36",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.5 9.75C16.5 15.75 7.5 12 7.5 17.25",
      stroke: "#212B36",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }));
  };
});
